exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1023px){section.section-home-hero[data-v-2d2f404b]{min-height:550px}}@media (min-width:768px){section.section-home-hero[data-v-2d2f404b]{min-height:900px}}@media (min-width:1024px){section.section-home-hero[data-v-2d2f404b]{min-height:900px}}@media (min-width:1280px){section.section-home-hero[data-v-2d2f404b]{min-height:900px}}@media (min-width:1920px){section.section-home-hero[data-v-2d2f404b]{min-height:1080px}}", ""]);

// exports
